import { DEGREES_TO_M, MILES_TO_M } from '../const'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class SnapToGrid extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.snaptogrid',
        group: 'Spatial Operations',
        title: 'ST Snap to Grid',
        description: `
      This component snaps an input geography to a grid of a given size (in degrees).
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'gridsize',
          type: WorkflowComponentParamType.Number,
          title: 'Grid size',
          default: 0.1
        },
        {
          name: 'units',
          type: WorkflowComponentParamType.Selection,
          title: 'Units',
          options: ['Meters', 'Miles'],
          default: 'Meters'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    const convert = params.units === 'Meters' ? '' : ` * ${MILES_TO_M}`
    switch (connection.type) {
      case Provider.BigQuery:
        return `  WITH gridsize AS(
                    SELECT
                    ${params.gridsize} ${convert} / ${DEGREES_TO_M}
                    / COS(
                      (
                        ST_EXTENT(${params.geo}).ymin
                        + ST_EXTENT(${params.geo}).ymax
                      )
                      * 3.1415926535897931 / 360) AS size
                    FROM ${connection.quoteName(params.source as string)}
                  )
                  SELECT
                    ST_SNAPTOGRID(${params.geo}, size)
                    AS ${params.geo}_snapped, org.*
                  FROM
                    ${connection.quoteName(params.source as string)} org,
                    gridsize`
      case Provider.Postgres:
        return `SELECT
                  ST_TRANSFORM(
                    ST_SNAPTOGRID(
                      ST_TRANSFORM(
                        ${params.geo}, 3857
                      ),
                      ${params.gridsize} ${convert},
                      ${params.gridsize} ${convert}
                    ),
                    ST_SRID(${params.geo})
                  )
                  AS ${params.geo}_snapped, *
                FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_snapped`,
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres]
  }
}

export { SnapToGrid }
